import React from 'react';
import PropTypes from 'prop-types';
import { IncludedRelationshipProvider } from 'Views/Page/Contexts/IncludedRelationshipContext';
import fr from 'facet-rest';
import Container from './Container';

const HierarchicalListNode = ({
  resource,
  isChild,
  onClickItem,
}) => {
  return (
    <IncludedRelationshipProvider
      relationship={resource.relationship(fr.relationships.children.name)}
    >
      <Container
        resource={resource}
        isChild={isChild}
        onClickItem={onClickItem}
      />
    </IncludedRelationshipProvider>
  );
};

HierarchicalListNode.defaultProps = {
  onClickItem: null,
};

HierarchicalListNode.propTypes = {
  resource: PropTypes.object.isRequired,
  isChild: PropTypes.bool.isRequired,
  onClickItem: PropTypes.func,
};

export default HierarchicalListNode;
